import { TopologySubscription } from '../../../../../services/eventingApi';
import DeliveryIssueBadge from '../shared/DeliveryIssueBadge';
import { subscribedEventTypes } from '../shared/subscriptions';
import { classNames } from '../shared/ui';

interface SubscriptionRowProps {
  subscription: TopologySubscription;
  onOpenConsumer: (consumer: string) => void;
}

const SubscriptionRow = ({ subscription, onOpenConsumer }: SubscriptionRowProps) => {
  const types = subscribedEventTypes(subscription);
  const hasDeadLetters = (subscription.deadLetterMessages ?? 0) > 0;

  return (
    <tr className="border-t border-gray-100 align-top dark:border-gray-700 dark:text-gray-100">
      <td className="px-2 py-2 font-mono">
        {subscription.queueName ? (
          <button type="button" className="text-blue-600 hover:underline dark:text-blue-400" onClick={() => onOpenConsumer(subscription.consumer)}>
            {subscription.consumer}
          </button>
        ) : (
          subscription.consumer
        )}
        <div className="mt-1 font-sans">
          <DeliveryIssueBadge subscription={subscription} />
        </div>
      </td>
      <td className="px-2 py-2">{subscription.protocol}</td>
      <td className="max-w-md px-2 py-2 text-xs">{types.length ? types.join(', ') : 'todos'}</td>
      <td className="px-2 py-2">{subscription.visibleMessages ?? '—'}</td>
      <td className="px-2 py-2">{subscription.inFlightMessages ?? '—'}</td>
      <td className={classNames('px-2 py-2', { 'font-semibold text-red-600 dark:text-red-400': hasDeadLetters })}>
        {subscription.deadLetterQueueName ? subscription.deadLetterMessages : '—'}
      </td>
    </tr>
  );
};

export default SubscriptionRow;
